import React, { Component } from 'react';
import styled from 'styled-components';
import Slide from './Slide';
import { LeftButton, RightButton } from './Buttons';
import { breakpointsMinWidth } from '../../../../../../../common/styling';

const SlidesWrap = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  height: 100%;

  perspective: 1050px;
  transform-style: preserve-3d;
`;
const Button = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  padding: 0;
  position: absolute;
  font-size: 12px;
  width: 48px;
  height: 48px;
  top: 43%;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }

  &:nth-of-type(1) {
    left: -78%;
  }
  &:last-child {
    right: -78%;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    width: 64px;
    height: 64px;
    top: 45%;
    &:nth-of-type(1) {
      left: -80%;
    }
    &:last-child {
      right: -80%;
    }
  }
  @media ${breakpointsMinWidth.tabletMd} {
    &:nth-of-type(1) {
      left: -115%;
    }
    &:last-child {
      right: -115%;
    }
  }
`;

class Slides extends Component {
  state = {
    // eslint-disable-next-line react/destructuring-assignment
    slideIndex: Math.round(this.props.length / 2),
    currentElement: null,
    px: 0,
    py: 0,
    tabChange: false,
  };

  componentDidMount = () => {
    const el = document.querySelector('#activeCard3d');

    this.setState({ currentElement: el });

    el.addEventListener('mousemove', this.handleMouseMove);
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { data } = this.props;
    const el = document.querySelector('#activeCard3d');
    const prevEl = prevState.currentElement;
    if (prevEl && el !== prevEl) {
      this.setState({ currentElement: el });
      el.addEventListener('mousemove', this.handleMouseMove);
      prevEl.removeEventListener('mousemove', this.handleMouseMove);
    }
    if (prevProps.data !== data) {
      this.setState({ tabChange: true });
    }
  };

  componentWillUnmount = () => {
    const { currentElement: el } = this.state;

    el.removeEventListener('mousemove', this.handleMouseMove);
  };

  handleMouseMove = (e) => {
    const { currentElement: el } = this.state;

    if (!el) {
      return;
    }
    const rect = el.getBoundingClientRect();
    const mouseX = e.clientX;
    const mouseY = e.clientY;
    const px = (mouseX - rect.left) / rect.width;
    const py = (mouseY - rect.top) / rect.height;

    this.setState({ px, py });
  };

  handleIncrease = () => {
    const { data } = this.props;
    const { slideIndex } = this.state;
    const { length } = data;
    const updatedIndex = (slideIndex + 1) % length;
    this.setState({ slideIndex: updatedIndex, tabChange: false });
  };

  handleDecrease = () => {
    const { data } = this.props;
    const { slideIndex } = this.state;
    const { length } = data;
    const updatedIndex = slideIndex === 0 ? length - 1 : slideIndex - 1;
    this.setState({ slideIndex: updatedIndex, tabChange: false });
  };

  render() {
    const { data, length } = this.props;
    const { slideIndex, px, py, tabChange } = this.state;

    return (
      <SlidesWrap>
        {[...data, ...data, ...data].map((slide, i) => {
          const offset = length + (slideIndex - i);
          const active = offset === 0 ? true : null;
          let dir = 0;

          const tiltx = `${(px - 0.5) * 7.5}deg`;
          const tilty = `${(py - 0.5) * -7.5}deg`;

          if (offset > 0) dir = -1;
          else if (offset < 0) dir = 1;

          return (
            <Slide
              tabChange={tabChange}
              tiltx={tiltx}
              tilty={tilty}
              slide={slide}
              key={`${i + 1}`}
              offset={offset}
              active={active}
              dir={dir}
            />
          );
        })}

        <Button
          onClick={this.handleIncrease}
          onMouseEnter={this.handleMouseMove}
          aria-label="Previous Template"
        >
          <LeftButton />
        </Button>

        <Button onClick={this.handleDecrease} aria-label="Next Template">
          <RightButton />
        </Button>
      </SlidesWrap>
    );
  }
}

export default Slides;
